import siteContent from '../content/site.json';

export const siteConfig = {
  ...siteContent,
  siteUrl: import.meta.env.VITE_SITE_URL || 'https://malevstudio.com',
} as const;
